export default __webpack_public_path__ + "images/0b0a9c8e1b093fe621f93d17795b43ce-hiking.webp";